import { render } from "./MyTeachers.vue?vue&type=template&id=1b99e5bd"
import script from "./MyTeachers.vue?vue&type=script&lang=js"
export * from "./MyTeachers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__